import { Command } from './types'

export const updateCardFrameViewSize = (args: { height: number; width: number; nodePos: number }): Command => {
  const { height, width, nodePos } = args

  return (state, dispatch) => {
    const { tr } = state
    const node = tr.doc.nodeAt(nodePos)
    if (node) {
      tr.setNodeMarkup(nodePos, undefined, {
        ...node.attrs,
        height,
        width,
      })
      dispatch?.(tr)
      return true
    }
    return false
  }
}
